import { render } from "./WCItemGroupDropdown.vue?vue&type=template&id=1c0eafd5"
import script from "./WCItemGroupDropdown.vue?vue&type=script&lang=js"
export * from "./WCItemGroupDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__